import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const insightsPortalAwarenessCampaignInsightsAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.InsightsPortalCampaign],
  },
]
